import type { CandidateResume } from '@entities/candidates';
import type { CandidateResumeEditValues } from '../types';

export const getCandidateResumeEditInitialValues = (
  resume: CandidateResume
): CandidateResumeEditValues => ({
  activitySphereIds: resume.activitySpheres.map(({ id }) => id),
  desiredJob: resume.desiredJob ?? '',
  skillIds: resume.skills.map(({ id }) => id.toString()),
  experience: resume.experience ?? '',
  salary: resume.salary?.toString() ?? '',
  currencyId: resume.currency?.id.toString() ?? '',
  paymentPeriodId: resume.paymentPeriod?.id.toString() ?? '',
  scheduleWorkIds: resume.scheduleWorks.map(({ id }) => id.toString()),
  employmentTypeIds: resume.employmentTypes.map(({ id }) => id.toString()),
});
